"use client";

import { ErrorBoundary } from "@/components/error-boundary";
import type { SidebarSection, TrendingTag } from "../types";
import { SidebarNewsletter } from "./sidebar-newsletter";
import { SidebarTopics } from "./sidebar-topics";
import { useStickyAside } from "./use-sticky-aside";

interface ExploreSidebarProps {
  activeTags?: string[];
  categoryName?: string;
  deals?: readonly unknown[];
  initialSearch?: string;
  sidebar: SidebarSection;
  tagDisplayNames?: Map<string, string>;
  trendingTags: TrendingTag[];
}

export function ExploreSidebar({
  activeTags,
  categoryName,
  deals: _deals,
  initialSearch,
  sidebar,
  tagDisplayNames,
  trendingTags,
}: ExploreSidebarProps) {
  const { ref, stickyTop } = useStickyAside({ mode: "reveal" });

  const topicCloudTags =
    trendingTags.length > 0
      ? trendingTags.map((tag) => ({
          slug: tag.slug,
          displayName: tag.displayName,
          count: tag.count,
        }))
      : sidebar.topics.map((t) => ({
          slug: t.slug,
          displayName: t.displayName,
        }));

  return (
    <aside
      className="hidden flex-col gap-4 self-start rounded-2xl bg-[var(--explore-bg-sidebar)] p-4 lg:sticky lg:flex"
      ref={ref}
      style={{ top: stickyTop }}
    >
      <SidebarTopics
        activeTags={activeTags}
        categoryName={categoryName}
        initialSearch={initialSearch}
        tagDisplayNames={tagDisplayNames}
        tags={topicCloudTags}
        tools={sidebar.tools}
      />
      {/* Newsletter form is the primary subscribe surface for desktop hubs.
          A render crash here would silently delete the form from the page,
          so we report it and render nothing rather than blowing up the
          whole sidebar. */}
      <ErrorBoundary source="sidebar_newsletter_boundary">
        <SidebarNewsletter />
      </ErrorBoundary>
    </aside>
  );
}
